import { Reveal, SectionHeading } from "@/components/Reveal";

const CHAPTERS = [
  {
    num: "01",
    title: "Metterci l'anima",
    body: "«Se vuoi comunicare efficacemente il tuo messaggio, devi metterci l'anima.» Non è uno slogan: è il principio da cui parto in ogni progetto, piccolo o grande.",
    id: "manifesto-chapter-01",
  },
  {
    num: "02",
    title: "Creatività applicata",
    body: "Giango è il primo studio di creatività applicata: idee creative, sì, ma mirate ed efficaci, pensate per rispondere alle esigenze reali dei clienti, nella comunicazione come nella formazione.",
    id: "manifesto-chapter-02",
  },
  {
    num: "03",
    title: "Ad hoc o di portafoglio",
    body: "Ogni azienda è diversa. Posso progettare da zero una soluzione su misura sul tuo brief, oppure attivare rapidamente format già collaudati del mio portafoglio.",
    id: "manifesto-chapter-03",
  },
];

export default function Manifesto() {
  return (
    <section id="manifesto" className="relative py-24 sm:py-32">
      <div className="max-w-[1400px] mx-auto px-6 sm:px-10">
        <SectionHeading
          overline="Il manifesto"
          title={<>Tre principi, un'unica ossessione: l'efficacia.</>}
          testId="manifesto-title"
        />

        <div className="border-t border-white/10">
          {CHAPTERS.map((c, i) => (
            <Reveal key={c.num} delay={i * 0.08}>
              <article
                data-testid={c.id}
                className="group grid grid-cols-1 md:grid-cols-12 gap-6 md:gap-8 items-start border-b border-white/10 py-12 md:py-16 hover:bg-surface/40 transition-colors duration-500 px-2 sm:px-4"
              >
                <span className="md:col-span-2 font-mono text-ember text-lg tracking-widest">
                  /{c.num}
                </span>
                <h3 className="md:col-span-4 font-display font-bold text-2xl sm:text-3xl lg:text-4xl text-ink group-hover:text-ember transition-colors duration-500">
                  {c.title}
                </h3>
                <p className="md:col-span-6 text-zinc-400 leading-relaxed text-base sm:text-lg">
                  {c.body}
                </p>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
